function paginateList(items, page, perPage) {

  if ( page && perPage) {
    const start = (page - 1) * perPage;
    return items.slice(start, start + perPage);
  }

  return items;
}

export default {
  paginateList
};